export default {
	"Wx.PleaseClickInTheUpperRightCornerToShare": "請點擊右上角【...】分享"
}